import { LatestBooks } from './components/LatestBooks';
import { Masthead } from './components/Masthead';
import { GenreHeader } from './components/GenreHeader';
import { Inklight } from './components/Inklight';
import './app.css';
// import { FavouriteBooks } from './components/FavouriteBooks';
import { User, Genre } from '@novelizing/types';

interface AppProps {
  user: User | null;
  genre?: Genre;
  featuredGenres?: Genre[];
}

export const App = ({ user, genre, featuredGenres }: AppProps) => {
  console.log({ user, genre, featuredGenres });
  const homePage = !genre;
  return (
    <>
      {homePage && <Masthead limit={48} />}
      {genre && <GenreHeader genre={genre} />}
      {/* {userId && <FavouriteBooks limit={16} />} */}
      {genre ? (
        <Inklight genre={genre} limit={16} />
      ) : (
        <LatestBooks limit={16} />
      )}
    </>
  );
};
